import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ORIGIN extends UltMeta {
    ZHIHAO = new Meta(2, "志豪集团企业成员");
    ENTERPRISE = new Meta(1, "企业定制用户");
}
export const USER_ORIGIN = new ORIGIN();
